import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/dialbot.vue
var c = {
	name: "DtIconDialbot",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["clip-path"], d = ["fill"], f = ["id"], p = ["id"];
function m(e, t, n, c, m, h) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([h.iconSizeClass, "d-icon d-icon--dialbot"]),
		"data-qa": h.dataQA,
		"aria-hidden": h.ariaHidden,
		role: "img",
		"data-name": "Dialbot",
		viewBox: "0 0 24 25",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [i("path", {
		d: "M12 24.5c6.627 0 12-5.373 12-12S18.627.5 12 .5 0 5.873 0 12.5s5.373 12 12 12Z",
		fill: `url(#${e.uniqueID}b)`
	}, null, 8, d), t[0] || (t[0] = i("path", {
		d: "M17.8 18.5v.8h1.295l-.58-1.158-.715.358Zm-1.121-2.243-.624-.501-.321.4.23.459.715-.358ZM12 7.3a5.2 5.2 0 0 1 5.2 5.2h1.6A6.8 6.8 0 0 0 12 5.7v1.6Zm-5.2 5.2A5.2 5.2 0 0 1 12 7.3V5.7a6.8 6.8 0 0 0-6.8 6.8h1.6Zm5.2 5.2a5.2 5.2 0 0 1-5.2-5.2H5.2a6.8 6.8 0 0 0 6.8 6.8v-1.6Zm5.8 0H12v1.6h5.8v-1.6Zm-1.837-1.085 1.122 2.243 1.43-.716-1.12-2.243-1.432.716ZM17.2 12.5a5.175 5.175 0 0 1-1.145 3.256l1.247 1.002A6.775 6.775 0 0 0 18.8 12.5h-1.6Zm-2 1.6a4.823 4.823 0 0 1-1.491.886 4.816 4.816 0 0 1-3.418 0A4.822 4.822 0 0 1 8.8 14.1v-.8c.295.178.628.33.999.46a7.59 7.59 0 0 0 1.127.313 5.58 5.58 0 0 0 1.077.114c.338 0 .697-.038 1.078-.114a7.59 7.59 0 0 0 1.127-.313c.371-.13.702-.282.992-.46v.8Z",
		fill: "#fff"
	}, null, -1))], 8, u), i("defs", null, [i("linearGradient", {
		id: `${e.uniqueID}b`,
		x1: "-3.75",
		y1: "-4.675",
		x2: "24.75",
		y2: "24.5",
		gradientUnits: "userSpaceOnUse"
	}, [...t[1] || (t[1] = [a("<stop offset=\".06\" stop-color=\"#10022C\"></stop><stop offset=\".2\" stop-color=\"#611F93\"></stop><stop offset=\".29\" stop-color=\"#8223A1\"></stop><stop offset=\".366\" stop-color=\"#9325A5\"></stop><stop offset=\".459\" stop-color=\"#C52599\" stop-opacity=\".9\"></stop><stop offset=\".564\" stop-color=\"#D52C86\"></stop><stop offset=\".658\" stop-color=\"#EA2F6F\"></stop><stop offset=\".737\" stop-color=\"#F64850\"></stop><stop offset=\".896\" stop-color=\"#FD6D2D\"></stop><stop offset=\".955\" stop-color=\"#FF9E0E\" stop-opacity=\".95\"></stop>", 10)])], 8, f), i("clipPath", { id: `${e.uniqueID}a` }, [...t[2] || (t[2] = [i("path", {
		fill: "#fff",
		transform: "translate(0 .5)",
		d: "M0 0h24v24H0z"
	}, null, -1)])], 8, p)])], 10, l);
}
var h = /* @__PURE__ */ n(c, [["render", m]]);
//#endregion
export { h as default };

//# sourceMappingURL=dialbot.js.map